import React, { useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const fadeInUpVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
  exit: { opacity: 0, y: -30, transition: { duration: 0.4, ease: "easeIn" } },
};

const ContactPage = ({ isActive }) => {
  // 2. CREATE the ref for the h2 element
  const titleRef = useRef(null);

  // REMOVED: The chaosKey state is not needed for the title animation.
  // It's better to handle background animations with pure CSS if they just loop.

  // 3. ADD the useEffect hook for the mouse-tracking animation
  useEffect(() => {
    // Only run the animation logic if the page is active
    if (!isActive) return;

    const title = titleRef.current;
    // Find the parent page container to track the mouse over the whole area
    const page = title.closest(".contact-page");

    // Safety check in case elements aren't found
    if (!title || !page) return;

    const handleMouseMove = (e) => {
      const { clientWidth, clientHeight } = page;
      const centerX = clientWidth / 2;
      const centerY = clientHeight / 2;
      const mouseX = e.clientX;
      const mouseY = e.clientY;

      const x = (mouseX - centerX) / clientWidth;
      const y = (mouseY - centerY) / clientHeight;
      const maxMove = 25; // Adjust this value to make the effect more or less subtle

      const moveX = x * -maxMove;
      const moveY = y * -maxMove;

      // Apply the transform while preserving the original rotation
      title.style.transform = `translate(${moveX}px, ${moveY}px) rotate(-1deg)`;
    };

    const handleMouseLeave = () => {
      // Reset the title's position when the mouse leaves
      title.style.transform = `rotate(-1deg)`;
    };

    // Add the event listeners
    page.addEventListener("mousemove", handleMouseMove);
    page.addEventListener("mouseleave", handleMouseLeave);

    // Cleanup function: remove the listeners when the component unmounts or isActive becomes false
    return () => {
      page.removeEventListener("mousemove", handleMouseMove);
      page.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [isActive]); // The effect depends on the 'isActive' prop

  return (
    <div className="page contact-page">
      <AnimatePresence>
        {isActive && (
          <motion.div
            className="contact-content-wrapper" // Renamed to avoid class name collision
            key="contact-content-wrapper"
            variants={fadeInUpVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <div className="contact-content">
              {/* 4. ATTACH the ref to your h2 element */}
              <h2 ref={titleRef}>LET'S CONNECT?</h2>
              <p
                style={{
                  fontSize: "1.4rem",
                  marginBottom: "20px",
                  color: "#000",
                }}
              >
                Let’s join forces to solve interesting problems
              </p>
              <div className="contact-links">
                <a
                  href="mailto:lavanyakulkarni2131@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="contact-link"
                >
                  EMAIL ME
                </a>
                <a
                  href="https://www.instagram.com/lavanya._k__/"
                  target="_blank"
                  rel="noreferrer"
                  className="contact-link"
                >
                  INSTAGRAM
                </a>
                <a href="#" className="contact-link">
                  TWITTER
                </a>
                <a
                  href="https://www.linkedin.com/in/lavanya-kulkarni-bb38a1282/"
                  target="_blank"
                  rel="noreferrer"
                  className="contact-link"
                >
                  LINKEDIN
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ContactPage;
